import { useContext } from 'react'
import { ConsentContext } from '@/services/components/strategies/privacy/ConsentContext'

export const useConsent = () => {
  const { consent } = useContext(ConsentContext)
  const isConsentReady = !!consent?.tcString
  return { isConsentReady, consent }
}
